import React, {useEffect, useRef, useState} from 'react';
import {FieldProps, wdiCore, WdiModalAppProps} from '@/components/WdiControls';
import {ProFormInstance} from '@ant-design/pro-form';
import {EC} from '@/services/mdm/ec';
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {Form, Input, message} from 'antd';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {BO} from '@/services/mdm/bo';
import {ResponseStatus} from '@/utils/request';
import {FormBudgetProject} from '@/services/sales/bp/formBudgetProject';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {Enum} from '@/enums/system';
import {Product} from '@/services/mdm/product';

const {TextArea} = Input;

const ModalAppTypeEnums = {
  None: 0,
  Insert: 1,
  Edit: 2,
  Import: 3,
};

const FormBPDetailEditApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const {pageTypeId} = props.data;
  const [expandKeysEc, setExpandKeysEc] = useState<string[]>();

  useEffect(() => {
    if (props.data.row) {
      const detail = props.data.row;
      formRef.current?.setFieldsValue({
        budgetProjectDetailId: detail.budgetProjectDetailId,
        formBudgetProjectDetailId: detail.formBudgetProjectDetailId,
        rowNumber: detail.rowNumber,
        boId: {label: detail.boName, value: detail.boId},
        ecId: {label: detail.ecName, value: detail.ecId},
        productId: {
          label: wdiCore.String.CodeOrName(detail.productCode, detail.productName),
          value: detail.productId,
        },
        amount: detail.amount,
        remark: detail.remark,
      });
      setExpandKeysEc([detail.ecId]);

    }
  }, [props.data.row]);

  return (
    <WdiModalForm
      {...HorzLayoutOpts}
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.();
        },
      }}
      onFinish={async (values) => {
        const {boId, ecId, productId, ...entity} = values;
        const response = await FormBudgetProject.Buttons.validateDetail({
          rowIndex: props.data.rowIndex,
          formBudgetProject: {
            pageTypeId: props.data.pageTypeId,
          },
          formBudgetProjectDetail: {
            ...entity,
            boId: WdiSelectFormat.getvalue(boId),
            ecId: WdiSelectFormat.getvalue(ecId),
            productId: WdiSelectFormat.getvalue(productId),
          },
          formBudgetProjectDetails: props.data.rows,
        });
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
        } else {
          if (props.onSave) {
            props.onSave(response);
          }
        }
      }}
    >
      <Form.Item name="budgetProjectDetailId" label="budgetProjectDetailId" hidden>
        <Input/>
      </Form.Item>
      <Form.Item name="formBudgetProjectDetailId" label="formBudgetProjectDetailId" hidden>
        <Input/>
      </Form.Item>
      <Form.Item name="rowNumber" label="rowNumber" hidden>
        <Input/>
      </Form.Item>
      <Form.Item
        name="boId"
        label="使用部门"
        rules={[
          {required: !(props.type === ModalAppTypeEnums.Edit), message: '使用部门不能为空!'},
        ]}
      >
        <WdiTreeSelect
          {...{
            placeholder: '请选择使用部门',
            labelInValue: true,
            isExpanded: false,
            dataLoading: async (params) => {
              const response = await BO.search({
                isActive: true,
                withPermissions: true,
                boLevels: [
                  Enum.BOLevel.BO1,
                  Enum.BOLevel.BO2,
                  Enum.BOLevel.BO3,
                  Enum.BOLevel.BO4,
                ].join(),
              });
              const {treeData, dict} = FieldProps.TreeSelect.formatTreeData(
                {
                  textField: 'boName',
                  valueField: 'boId',
                  id: 'boId',
                  pId: 'parentId',
                },
                response.data,
              );
              return {treeData, dict};
            },
            disabled: props.type === ModalAppTypeEnums.Edit,
          }}
        />
      </Form.Item>
      <Form.Item name="ecId" label="费用类别"
                 rules={[
                   {required: !(props.type === ModalAppTypeEnums.Edit), message: '费用类别不能为空!'},
                 ]}>
        <WdiTreeSelect
          {...{
            placeholder: '请选择费用类别',
            defaultExpandKeys: expandKeysEc,
            disabled: props.type === ModalAppTypeEnums.Edit,
            dataLoading: async (params) => {
              const response = await EC.searchEc3(
                Object.assign(
                  {
                    bohqId: props.data.bohqId,
                    toParentLevel: String(Enum.ECLevel.EC1),
                    isActive: true,
                    pageTypeIds: String(pageTypeId),
                   // ecLevel: Enum.ECLevel.EC2
                  },
                  params,
                ),
              );
              const {treeData, dict} = FieldProps.TreeSelect.formatTreeData(
                {
                  textField: 'ecName',
                  valueField: 'ecId',
                  id: 'ecId',
                  pId: 'parentId',
                  level: 'ecLevel',
                  disabledLevel: [Enum.ECLevel.ROOT],
                },
                response.data,
              );
              return {treeData, dict};
            },
            reloadKey: props.data.bohqId,
          }}
        />
      </Form.Item>

      <Form.Item name="productId" label="品牌" rules={[{required: true}]}>
        <WdiSelect
          {...{
            placeholder: '请选择品牌',
            showSearch: true,
            labelInValue: true,
            disabled: props.type === ModalAppTypeEnums.Edit,
            dataLoading: async (params) => {
              const response = await Product.ajaxSearchLevel1(
                Object.assign(
                  {
                    withPermissions: true,
                    isActive: true,
                  },
                  params,
                ),
              );
              return response?.data?.map((item) => {
                return {value: item.productId, label: item.codeOrName};
              });
            },
          }}
        />
      </Form.Item>
      <Form.Item
        name="amount"
        label="分配金额"
        rules={[{required: true, message: '分配金额不能为空!'}]}
      >
        <WdiInputNumber digits={2}/>
      </Form.Item>
      <Form.Item name="remark" label="备注">
        <TextArea rows={3} style={{width: '100%'}} maxLength={2000}/>
      </Form.Item>
    </WdiModalForm>
  );
};
export default FormBPDetailEditApp;
